import type { UiSchema } from '@rjsf/utils';
import type { JSONSchema7 } from 'json-schema';

export const schema = {
  type: 'object',
  properties: {
    channel: { type: 'string', title: 'Channel' },
  },
  required: ['channel'],
} satisfies JSONSchema7;

export const uiSchema = {
  channel: {
    'ui:widget': 'VariableSelectWidget',
    'ui:description':
      "Pick a channel configured in Pusher settings, or enter a custom channel name — the 'private-' prefix is added automatically, just type the plain name.",
  },
} satisfies UiSchema;
